import axios from "axios";
import {serviceData} from "@/constants";

// action types
export const IMG_GET = "imgGet";

// mutation types
export const SET_IMG = "setImg";

const state = {
    images: new Map()
};

const getters = {
    getImg(state) {
        return state.images;
    }
};

const actions = {
    [IMG_GET](context, animeId) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/image/${animeId}`, {headers: {[serviceData.MAL_HEAD]: serviceData.MAL_ID}}).then(response => {
                context.commit(SET_IMG, response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};

const mutations = {
    [SET_IMG](state, data) {
        state.images.set(data.id, data.main_picture.large);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
